import PageExplore  from '../views/Explore'
import PageNotFound from '../views/NotFound'

const ROUTES = [
  {
    path: '/',
    name: 'home',
    title: 'Home',
    redirect: '/explore/3d'
  },
  {
    path: '/explore/:type/:x?/:y?/:lat?/:lon?',
    name: 'explore',
    title: 'Explore',
    component: PageExplore
  },
  {
    path: '/not-found',
    name: 'not-found',
    title: 'NotFound',
    component: PageNotFound
  }
]

export default ROUTES
